module.exports = __webpack_public_path__ + "assets/img/home-zggs.d0ef6d63.png";